export default "__VITE_ASSET__415c6c31__"